import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const gulfportConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Gulfport Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Gulfport, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_gulfport',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Gulfport',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Gulfport Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the eclectic 
     waterfront community of <strong>Gulfport</strong>. Sitting right on Boca Ciega Bay, 
     properties here face constant salt air exposure, strong Gulf winds, and the storm 
     pressure that comes with living on the water. Mature trees that shade beautiful yards 
     can quickly become hazards when roots weaken, canopies overgrow, or a storm rolls 
     through and splits a trunk near your home.`,

    `We specialize in <strong>hazardous tree removal and precision coastal trimming</strong> 
     overhanging limbs threatening rooftops and docks, salt damaged canopies, leaning palms 
     near structures, and dense overgrowth that increases your storm risk every hurricane 
     season. We handle tight residential lots with care and work cleanly from start to finish.`,

    `<strong>Sam's Tree Service</strong> provides reliable, professional tree care 
     throughout <strong>Gulfport</strong> and the surrounding <strong>South Pinellas 
     County</strong> waterfront communities keeping your property safe and your 
     landscape healthy all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Gulfport, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Gulfport = () => <LocationPage config={gulfportConfig} />;
export default Services_Gulfport;
